// extracted by mini-css-extract-plugin
module.exports = {"menu":"style_menu__3hPN_","submitButton":"style_submitButton__psthI","modalSuccessForm":"style_modalSuccessForm__2yMBW"};